
export default {
  components: {
    ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip')
  },
  props: ['value', 'field', 'selection', 'isDisabled'],
  data: () => ({
    hasError: false
  }),
  computed: {
    advancedOptionListResponsiveView() { return this.$store.state.store.advancedOptionListResponsiveView }
  },
  methods: {
    async onChange(e) {
      this.hasError = false
      if(e.target.files && e.target.files[0] instanceof File ) {
        const file = e.target.files[0]
        if (file.size > 1000000) {
          this.hasError = false;
          return;
        }

        if (this.field.customVariables.allowedExts) {
          let found = false
          this.field.customVariables.allowedExts.forEach(ext => {
            if(e.target.files[0].name.substr(-ext.length).toLowerCase() === ext) {
              found = true
            }
          })
          if (!found) {
            this.hasError = true
            return
          }
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.$emit('input', {
            name: file.name,
            content: btoa(e.target.result)
          })
        }
        reader.onerror = error => {
          this.hasError = true
        }
        reader.readAsText(file)
      }
    }
  }
}
